const images = {
  logo: require("./common/logo.svg"),
};

export default images;
